/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from '../helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/DesignSystem/EditAutomation/SaveAction/No",
  isDisabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isDisabled
  
})
let automationEventIdValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'event_id',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 disabled={isDisabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={automationEventIdValueData ? "Save automation" : "Add new automation"}
 data="automation.event_id"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}